import styled from 'styled-components'
import Button from 'components/Button/Button'

export const MergeLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const MergeLayoutSection = styled.div`
  display: flex;
`

export const MergeColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`
export const Divider = styled.hr`
  width: 100%;
`

export const MergeButton = styled(Button)`
  margin: 5px;
`
export const MergeColumnTitle = styled.div`
  margin: 5px;
  font-size: 1rem;
  font-weight: bold;
  text-decoration: underline;
`
